import React, { useState } from "react";


// Props definition for the toggle switch
interface ToggleSwitch2Props {
  onlineText2: string; // Text for the online state
  offlineText2: string; // Text for the offline state
  onlineColor: string; // Background color for online state
  offlineColor: string; // Background color for offline state
  initialState?: boolean; // Optional initial state
  onToggle?: (state: boolean) => void; // Callback for state changes
}

const ToggleSwitch2: React.FC<ToggleSwitch2Props> = ({
  onlineText2,
  offlineText2,
  onlineColor,
  offlineColor,
  initialState = false,
  onToggle,
}) => {
  // State to manage toggle
  const [isOnline2, setisOnline2] = useState<boolean>(initialState);

  // Handle toggle change
  const handleToggle2 = () => {
    const newState = !isOnline2;
    setisOnline2(newState);
    if (onToggle) {
      onToggle(newState); // Notify parent component
    }
  };

  return (
    <div className={`toggle-switch ${isOnline2 ? 'on' : 'off'}`}>
      <input
        type="checkbox"
        className="toggle-switch-checkbox"
        id="toggle-switch"
        checked={isOnline2}
        onChange={handleToggle2}
      />
      <label
        className="toggle-switch-label"
        htmlFor="toggle-switch"
        style={{
          backgroundColor: isOnline2 ? onlineColor : offlineColor,
        }}
      >
        <span className="toggle-switch-inner">
          {isOnline2 ? onlineText2 : offlineText2}
        </span>
        <span className="toggle-switch-switch" />
      </label>
    </div>
  );
};

export default ToggleSwitch2;
